module.exports = __webpack_public_path__ + "img/top.a2f0b3b5.png";